import { render, staticRenderFns } from "./PwaNotification.vue?vue&type=template&id=0f45a8c5&scoped=true&"
import script from "./PwaNotification.vue?vue&type=script&lang=js&"
export * from "./PwaNotification.vue?vue&type=script&lang=js&"
import style0 from "./PwaNotification.vue?vue&type=style&index=0&id=0f45a8c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45a8c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f45a8c5')) {
      api.createRecord('0f45a8c5', component.options)
    } else {
      api.reload('0f45a8c5', component.options)
    }
    module.hot.accept("./PwaNotification.vue?vue&type=template&id=0f45a8c5&scoped=true&", function () {
      api.rerender('0f45a8c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PwaNotification.vue"
export default component.exports